import i18next from 'i18next';
import { gql } from '@apollo/client';
import { useQueryWithSimpleErrorHandling } from '@ts-private/apollo-tools-ts';
import { useDispatch } from 'react-redux';
import { showError } from 'actions/actionCreators/snackbarActions';

const FILE_VALIDATION_RULES_QUERY = gql`
  query fileValidationRules {
    fileValidationRules {
      maxSize
      allowedExtensions
    }
  }
`;

const getFileExtension = fileName => {
  return fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length) || fileName;
};

const useFileValidationRules = () => {
  const { data: fileValidationRules } = useQueryWithSimpleErrorHandling(FILE_VALIDATION_RULES_QUERY, {});
  const maxSize = fileValidationRules?.fileValidationRules?.maxSize;
  const dispatch = useDispatch();

  const validateFileExtension = file => {
    const extension = getFileExtension(file.name).toLowerCase();
    const allowedExtensions = fileValidationRules.fileValidationRules.allowedExtensions;
    if (allowedExtensions.find(x => x.toLowerCase() === extension)) return true;

    dispatch(
      showError(
        i18next.t('OfferEdit.Documents.UnsupportedFileExtension', {
          extension,
          allowedExtensions: allowedExtensions.toString().toLowerCase()
        })
      )
    );
    return false;
  };

  const validateFileSize = file => {
    if (!maxSize) return true;
    if (file.size <= maxSize * 1048576) return true;

    dispatch(
      showError(
        i18next.t('OfferEdit.Documents.MaxFileSizeExcedeed', {
          maxSize
        })
      )
    );
    return false;
  };

  return { validateFileExtension, validateFileSize, maxSize };
};

export { useFileValidationRules };
